export default __webpack_public_path__ + "static/media/top-section-desk.e67e4bd9.jpg";